import {EWedletEditMode, EWedletEditModeLabel, IElementWedlet, IWedlet, WEDLET} from "/@back@/edit/wed/wedlets/wedlet.js";
import {IJmlNode} from "/@lib@/commons/xml/jml.js";
import {DOMSH} from "/@lib@/commons/xml/domsh.js";
import {DOM, JSX} from "/@lib@/commons/xml/dom.js";
import {ORemoteViewInit, RemoteView} from "/@back@/wsp/widgets/remoteView.js";
import {BoxContainer, removeAnnots} from "/@back@/edit/wed/wedlets/box/boxTags.js";
import {IXmlMsg} from "/@lib@/edit/ot/xmlHouse.js";
import {LANG} from "/@lib@/commons/lang.js";
import {IReg, REG} from "/@lib@/commons/registry.js";
import {Button, OButtonInit} from "/@back@/commons/widgets/buttons.js";
import {POPUP} from "/@back@/commons/widgets/popups.js";
import {ERROR} from "/@lib@/core/errorReport.js";
import {IO} from "/@lib@/commons/io/io.js";
import {IItemUiEnv} from "/@back@/wsp/views/itemMain.js";

/**
 * @deprecated
 * BoxRemoteView sans la nouvelle approche JRemoteResDesc à partir sc6.1 -  TODOsc7 à suppr
 * Affiche une ressource remote
 *    <box-remote-view tag="iframe">
 *      <locationAsSrc>
 *				<queryStringParam keySvc?="scDepot">json</queryStringParam>{*}
 *      </locationAsSrc
 *      <scDepotView code="maVIew" />
 *    </box-remote-view>
 */
export class BoxRemoteView extends BoxContainer implements IElementWedlet {

	remoteViewElt: RemoteView;

	url: string;

	constructor() {
		super();
		this.style.userSelect = "none";
	}

	configWedletElt(tpl: Element, wedlet: IWedlet) {
		const wedMgr = wedlet.wedMgr;
		const reg = wedMgr.reg;
		const sr = this.attachShadow(DOMSH.SHADOWDOM_INIT);
		WEDLET.installSkins(tpl, sr, wedlet, this.localName);
		this.remoteViewElt = sr.appendChild(<RemoteView î={BoxRemoteView.makeRemoteViewInit(tpl, wedlet)}/>) as RemoteView;
		this.remoteViewElt.wsp = reg.env.wsp;
		this.remoteViewElt.fields = reg.env.longDesc;
	}

	static makeRemoteViewInit(tpl: Element, wedlet: IWedlet): ORemoteViewInit {
		const init: ORemoteViewInit = {viewers: []};
		if (tpl.hasAttribute("tag")) init.tag = tpl.getAttribute("tag") as "img" | "video" | "audio" | "iframe";
		Array.from(tpl.children).forEach((elt) => {
			switch (elt.nodeName) {
			case "locationAsSrc" :
				const queryStringParams: { keySvc?: 'scDepot' | string, value: any }[] = [];
				Array.from(elt.children).forEach((paramElt) => {
					if (paramElt.nodeName === 'queryStringParam') {
						let obj: { keySvc?: 'scDepot' | string, value: any } = {
							value: JSON.parse(paramElt.textContent)
						};
						if (paramElt.hasAttribute('keySvc'))
							obj.keySvc = paramElt.getAttribute('keySvc');
						queryStringParams.push(obj);
					}
				});
				init.viewers.push({type: 'locationAsSrc', queryStringParams});
				break;
			case "scPortalView" ://deprecated [5.0]
			case "scDepotView" :
				init.viewers.push({type: 'scDepotView', code: elt.getAttribute("code")});
				break;
			}
		});
		return init;
	}

	refreshBindValue(val: IJmlNode) {
		this.url = val as string;
		this.remoteViewElt.location = this.url;
		WEDLET.clearAnnots(this);
	}

	insertChars(from: number, chars: string, msg: IXmlMsg) {
		this.refreshBindValue(LANG.stringInsert(this.url, from, chars));
	}

	deleteChars(from: number, len: number, msg: IXmlMsg) {
		this.refreshBindValue(LANG.stringDelete(this.url, from, len));
	}

	replaceChars(chars: string, msg: IXmlMsg) {
		this.refreshBindValue(chars);
	}
}

window.customElements.define("box-remote-view", BoxRemoteView);
REG.reg.registerSkin('box-remote-view', 1, /* language=CSS */ `
	:host {
		display: block;
	}

	wsp-remote-view {
		height: 100%;
	}

`);


/**
 * @deprecated
 * BoxRemoteView sans la nouvelle approche JRemoteResDesc à partir sc6.1 -  TODOsc7 à suppr ;
 *  Affiche une ressource remote via un bouton
 *  	Si @tag vide ou non spécifié, la ressource est ouverte dans un nouvel onglet
 *    <box-remote-view-btn
 *    		visiblePerms="perm1"
 *        enablePerms="perm2"
 *    		tag?="iframe">
 *     cf box-remote-view
 *    </box-remote-view-btn>
 */
export class BoxRemoteViewBtn extends Button implements IElementWedlet {

	wedlet: IWedlet;

	protected remoteViewElt?: RemoteView;

	protected url: string;

	protected reg: IReg<IItemUiEnv>;

	protected openInNewTab = false;

	private remoteViewInit: ORemoteViewInit

	configWedletElt(tpl: Element, wedlet: IWedlet) {
		this.wedlet = wedlet;
		const wedMgr = wedlet.wedMgr;
		this.reg = wedMgr.reg;

		const init: OButtonInit = Object.assign({
			reg: this.reg,
			role: 'button',
			skin: tpl.getAttribute('skin'),
			skinOver: tpl.getAttribute('skinOver')
		}, this.buildInitFromAtts());

		if (!tpl.getAttribute("tag"))
			this.openInNewTab = true;

		this.initialize(init);

		this.remoteViewInit = BoxRemoteView.makeRemoteViewInit(tpl, wedlet);

		this.onclick = this.onClick.bind(this);
	}

	get visiblePerms(): string[] {return this.hasAttribute("visiblePerms") ? this.getAttribute("visiblePerms").split(" ") : null}

	get enablePerms(): string[] {return this.hasAttribute("enablePerms") ? this.getAttribute("enablePerms").split(" ") : null}

	async onClick(this: BoxRemoteViewBtn, ev: MouseEvent) {
		if (this.disabled) return;
		if (this.openInNewTab) {
			const error: { msg?: string | undefined } = {};
			RemoteView.resolveRemote(this.reg.env.wsp, this.remoteViewInit, this.reg.env.longDesc, this.url, error).then(async (url) => {
				try {
					if (error.msg) {
						throw error.msg;
					} else if (url) {
						let resp = await IO.openUrlExternal(url);
						if (typeof resp === "object")	ERROR.showError(resp);
					} else
						throw "Ressource invalide";
				} catch (e) {
					ERROR.show("Visualisation impossible", e);
				}
			});
		} else {
			if (!this.remoteViewElt) {
				this.remoteViewElt = <RemoteView î={this.remoteViewInit}/> as RemoteView;
				this.remoteViewElt.wsp = this.reg.env.wsp;
				this.remoteViewElt.fields = this.reg.env.longDesc;
			}
			this.remoteViewElt.location = this.url;
			POPUP.showDialog(this.remoteViewElt, this.reg.env.uiRoot, {
				titleBar: {barLabel: {label: this.label || "Visualisation"}},
				fixSize: false,
				resizer: {},
				initWidth: '60vw',
				initHeight: '60vh',
				closeOnCtrlEnter: true
			});
		}
	}

	setEditMode(mode: EWedletEditMode) {
		this.disabled = mode !== EWedletEditMode.write;
		DOM.setAttr(this, "edit-mode", EWedletEditModeLabel[mode]);
	}

	async refreshBindValue(val: IJmlNode) {
		this.url = val as string;
		this.classList.toggle("virtual", this.wedlet.isVirtual());
		if (this.wedlet.isVirtual()) removeAnnots(this);
		if (!this.url) {
			this.disabled = true;
		} else {
			DOM.setHidden(this, this.visiblePerms && !this.reg.hasPerm(this.visiblePerms));
			this.disabled = this.enablePerms && !this.reg.hasPerm(this.enablePerms) || !WEDLET.isWritableWedlet(this.wedlet);
		}
	}

	insertChars(from: number, chars: string, msg: IXmlMsg) {
		this.refreshBindValue(LANG.stringInsert(this.url, from, chars));
	}

	deleteChars(from: number, len: number, msg: IXmlMsg) {
		this.refreshBindValue(LANG.stringDelete(this.url, from, len));
	}

	replaceChars(chars: string, msg: IXmlMsg) {
		this.refreshBindValue(chars);
	}
}

window.customElements.define("box-remote-view-btn", BoxRemoteViewBtn);
REG.reg.registerSkin('box-remote-view-btn', 1, /* language=CSS */ `

`);